import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { getTenantState } from '../../store/selectors';

function WindowTitle(props) {
  return (
    <Helmet>
      {/* eslint-disable */}
      <title>
        me3
        {' '}
        {props.tenant.name}
        {' '}
        {props.children
          ? `- ${
              props.children.join ? props.children.join('') : props.children
            }`
          : ''}
      </title>
      {/* eslint-enable */}
    </Helmet>
  );
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);

  return {
    tenant,
  };
};

export default withRouter(connect(mapStateToProps)(WindowTitle));
